"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _constants = require("../constants");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["labelFontWeight", "label", "checked", "onChange", "disabled", "className"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function CheckboxWithLabel(props) {
  var labelFontWeight = props.labelFontWeight,
    label = props.label,
    checked = props.checked,
    onChange = props.onChange,
    disabled = props.disabled,
    className = props.className,
    otherProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var name = (0, _react.useMemo)(function () {
    return props.name || "checkbox-".concat(Math.random());
  }, [props.name]);
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Checkbox, (0, _extends2["default"])({
    id: name,
    name: name,
    value: name,
    checked: checked,
    onChange: onChange,
    disabled: disabled
  }, otherProps)), /*#__PURE__*/_react["default"].createElement(Label, {
    htmlFor: name,
    fontWeight: labelFontWeight,
    disabled: disabled
  }, label));
}
CheckboxWithLabel.defaultProps = {
  checked: false,
  disabled: false,
  labelFontWeight: 'normal'
};
var _default = CheckboxWithLabel;
exports["default"] = _default;
var Container = _styledComponents["default"].div.withConfig({
  displayName: "checkbox_with_label__Container"
})(["display:flex;align-items:baseline;"]);
var Label = _styledComponents["default"].label.withConfig({
  displayName: "checkbox_with_label__Label"
})(["font-size:14px;user-select:none;margin-left:", ";", " ", ";", " cursor:", ";", " opacity:", ";"], _constants.padding.tiny, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return (0, _constants.fontWeight)(props.fontWeight);
}, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return !!props.disabled ? 'default' : 'pointer';
}, /* @ts-expect-error Flow -> TS migration */'', function (props) {
  return props.disabled ? '0.5' : '1';
});
var Checkbox = _styledComponents["default"].input.attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "checkbox_with_label__Checkbox"
})(["margin:0;cursor:", ";"], function (props) {
  return !!props.disabled ? 'default' : 'pointer';
});
Checkbox.displayName = 'Checkbox';
Label.defaultProps = {
  // @ts-expect-error - TS2322 - Type '{ fontWeight: string; disabled: boolean; }' is not assignable to type 'Partial<WithOptionalTheme<{ form?: string | undefined; slot?: string | undefined; style?: CSSProperties | undefined; title?: string | undefined; ref?: ((instance: HTMLLabelElement | null) => void) | RefObject<...> | null | undefined; ... 252 more ...; htmlFor?: string | undefined; } & Partial<...>, DefaultTheme>>'.
  fontWeight: 'normal',
  disabled: false
};